import React from "react"
import { FaLinkedin, FaGithubSquare } from "react-icons/fa"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { CVIcon } from "../../assets/icons"
import classes from "./socialLinks.module.scss"

const SocialLinks = props => {
  const { t } = useTranslation()

  return (
    <ul className={props.listStyleClass}>
      <li className={classes.ListItem}>
        <a href={t("links.cv")} target="_blank" rel="noreferrer">
          <CVIcon />
        </a>
      </li>
      <li className={classes.ListItem}>
        <a href={t("links.linkedin")} target="_blank" rel="noreferrer">
          <FaLinkedin className="social-icon" />
        </a>
      </li>
      <li className={classes.ListItem}>
        <a href={t("links.github")} target="_blank" rel="noreferrer">
          <FaGithubSquare className="social-icon" />
        </a>
      </li>
    </ul>
  )
}

export default SocialLinks
